
const webweb = {

    header: undefined, 
    headerMenu: undefined,
    videoBanner: undefined,
    searchLink: undefined,
    searchModal: undefined,
    overlayBackground: undefined,
    main: undefined,
    menuDrawerClose: undefined,
    menuDrawerOpen: undefined,
    menuDrawer: undefined,
    shareThisAccordion: undefined,
  
    init() {
        this.header = document.querySelector('.header-wrapper');
        if (this.header) {
            this.headerMenu = this.header.querySelector('.header__inline-menu');
            this.searchLink = this.header.querySelector('.header__icon--search');
            this.searchModal = this.header.querySelector('.header__search');
        } 
        this.overlayBackground = document.querySelector('.overlay-bg');
        this.main = document.querySelector('main');
        this.menuDrawerClose = document.querySelector('.menu-drawer__icon-close');
        this.menuDrawerOpen = document.querySelector('.menu-drawer-container .header__icon');
        this.menuDrawer = document.getElementById('Details-menu-drawer-container');
        this.shareThisAccordion = document.querySelector('.accordion__content .sharethis-inline-share-buttons');
        
        this.addEventListeners();

        if (this.shareThisAccordion) {
            this.unhideShareButtons();
        }

        //this.setTrancySwitcher();
        this.setLangifySwitcher()
        this.wrapTables();

    },

    addEventListeners() {
        const announcementBar = document.getElementById('shopify-section-announcement-bar');
        if (announcementBar) {
          if (announcementBar.childElementCount > 0) announcementBar.classList.add('has-announcement');
        }
      
        if (this.header) {
            this.header.addEventListener('mouseenter', () => {
                this.header.classList.add('active');
            });

            this.header.addEventListener('mouseleave', () => {
                this.hideMegaMenu();
                this.header.classList.remove('active');
            }); 

            if (this.overlayBackground) {
                this.overlayBackground.addEventListener('transitionend', () => {
                    if (!this.overlayBackground.classList.contains('active')) {
                        this.overlayBackground.classList.remove('visible');
                    }
                });
                this.overlayBackground.addEventListener('click', () => {
                    this.hideHeaderSearch();
                    this.hideMegaMenu();
                    this.hideMenuDrawer();
                });
            }

            if (this.menuDrawer) {
                this.menuDrawer.querySelectorAll('.menu-drawer__menu.has-submenu > li > a').forEach(link => {
                    link.addEventListener('click', (ev) => {
                        if (!link.parentNode.classList.contains('active')) {
                            this.menuDrawer.querySelectorAll('.menu-drawer__menu li.active').forEach(active => active.classList.remove('active'));
                            link.parentNode.classList.add('active');
                        } else {
                            link.parentNode.classList.remove('active');
                        }
                        ev.preventDefault();                        
                    });
                });
            }

            if (this.menuDrawerClose) {
                this.menuDrawerClose.addEventListener('click', () => {
                    document.body.classList.remove('overflow-hidden-tablet');
                    this.hideOverlayBackground();
                });
            }

            if (this.menuDrawerOpen) {
                this.menuDrawerOpen.addEventListener('click', () => {
                    if (this.menuDrawer && this.menuDrawer.hasAttribute('open')) {
                        this.hideOverlayBackground();
                    } else {
                        this.showOverlayBackground();
                    }
                });
            }

            if (this.shareThisAccordion) {
                const details = this.shareThisAccordion.closest('details');
                if (details) {
                    details.addEventListener('click', () => {
                        this.unhideShareButtons();
                    });
                }
            }

            window.addEventListener('scroll', () => {
                requestAnimationFrame(() => {
                    if (this.header) {
                        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                        const windowHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
                        const darkTop = this?.header?.clientHeight || windowHeight * 0.1;
                        /* var wW = Math.max(document.documentElement.clientWidth, window.innerWidth || 0); */
                        if (scrollTop > darkTop && !this.header.classList.contains('dark')) {
                            this.header.classList.add('dark');
                        } else if (scrollTop <= darkTop && this.header.classList.contains('dark')) {
                            this.header.classList.remove('dark');
                        }
                    }
                });
            });
        }

        if (this.headerMenu) {
            this.headerMenu.querySelectorAll('.header__menu-item').forEach(item => {
                item.addEventListener('mouseenter', () => {
                    this.hideMegaMenu();
                    this.showMegaMenu(item);
                });
                item.addEventListener('click', (ev) => {
                    if (!item.parentNode.classList.contains('active')) {
                        this.hideMegaMenu();
                        this.showMegaMenu(item);
                        ev.preventDefault();
                    }
                    ev.preventDefault();
                    return false;
                });
            });
            this.headerMenu.querySelectorAll('.mega-menu__content').forEach(content => {
                content.addEventListener('mouseleave', () => {
                    this.hideMegaMenu();
                })
            });
        }

        if (this.megaMenuContent) {
        }

        if (this.searchLink) {
            this.searchLink.addEventListener('mouseenter', () => this.showHeaderSearch());
            this.searchLink.addEventListener('click', (ev) => {
                ev.preventDefault();
                this.showHeaderSearch();
            });
        }

        if (this.searchModal) {
            this.searchModal.addEventListener('mouseleave', () => this.hideHeaderSearch());
        }

        const variantSelects = document.querySelector('variant-selects');
        if (variantSelects) {
          variantSelects.dispatchEvent(new Event('change'));
          variantSelects.toggleAddButton(true, 'Bitte Größe auswählen', true);
        }

    },

    showMegaMenu(item) {
        const menu = item.parentNode.querySelector('.mega-menu__content');
        if (menu) {
            this.showOverlayBackground();
            menu.style.height = menu.firstElementChild.clientHeight + 'px';
            item.parentNode.classList.add('active');
            menu.classList.add('active');
            this.header.classList.add('mega-active');    
        }
    },

    hideMegaMenu() {
        if (this.headerMenu) {
            const active = this.headerMenu.querySelector('.mega-menu__content.active');
            if (active) {
                this.hideOverlayBackground();
                active.style.height = 0;
                active.classList.remove('active');
                active.closest('li').classList.remove('active');
                this.header.classList.remove('mega-active');
            }
        }
    },

    showHeaderSearch() {
        if (this.searchModal) {
            const prSearch = document.getElementById('predictive-search-results');
            let prSearchHeight = 0;
            if (!this.searchModal.classList.contains('active')) {
                this.searchModal.style.height = ((prSearch?.clientHeight || 0) + this.searchModal.firstElementChild.clientHeight) + 'px';
                this.searchModal.classList.add('active');
                this.header.classList.add('search-active');
                this.showOverlayBackground();
                setTimeout(() => { document.getElementById('Search-In-Modal').focus() }, 250);
                if (this.menuDrawer && this.menuDrawer.classList.contains('menu-opening')) this.hideMenuDrawer();
            }
        }
    },

    hideHeaderSearch() {
        if (this.searchModal) {
            this.hideOverlayBackground();
            this.searchModal.style.height = 0;
            this.searchModal.classList.remove('active');
            this.header.classList.remove('search-active');
        }
    },

    hideMenuDrawer() {
        if (this.menuDrawer) {
            this.menuDrawer.classList.remove('menu-opening');
            this.menuDrawer.removeAttribute('open');
        }
    },

    showOverlayBackground() {
        if (this.main) this.main.classList.add('blur');
        if (this.overlayBackground) {
            this.overlayBackground.classList.add('visible');
            setTimeout(() => { this.overlayBackground.classList.add('active') }, 1);
        }
    },

    hideOverlayBackground() {
        if (this.main) this.main.classList.remove('blur');
        if (this.overlayBackground) {
            this.overlayBackground.classList.remove('active');
        }
    },

    unhideShareButtons() {
        //console.log('unhideShareButtons', this.shareThisAccordion.childElementCount);
        if (!this.shareThisAccordion.childElementCount) {
            setTimeout(() => this.unhideShareButtons(), 100);
            return;
        }
        this.shareThisAccordion.classList.remove('st-animated');
        this.shareThisAccordion.querySelectorAll('.st-btn').forEach(btn => {
            const label = btn.querySelector('.st-label');
            if (btn.dataset['network'] == 'facebook') label.innerHTML = 'Facebook'
            else if (btn.dataset['network'] == 'email') label.innerHTML = 'Email' 
            else if (btn.dataset['network'] == 'whatsapp') label.innerHTML = 'WhatsApp';
            btn.style.display = ''
        });
    },

        //this 2 event handlers need to be added to predictive-search.js
    afterSearchResultOpen() {
        const prSearch = document.getElementById('predictive-search-results');
        if (this.searchModal && prSearch) {
            this.searchModal.style.height = (prSearch.clientHeight + this.searchModal.firstElementChild.clientHeight) + 'px';
        }
    },

    afterSearchResultClose() {
        if (this.searchModal && this.searchModal.classList.contains('active')) {
            this.searchModal.style.height = this.searchModal.firstElementChild.clientHeight + 'px';
        } else if (this.searchModal) {
            this.searchModal.style.height = 0;
        }
    },

    setTrancySwitcher() {
        const trancySwitcher = document.getElementById('transcySwitcherContainer');
        if (trancySwitcher) {
        console.log('trancySwitcher', trancySwitcher);
          const block = document.querySelector('.footer-block--localization');
          if (block) block.appendChild(trancySwitcher);
        } else {
          setTimeout(() => this.setTrancySwitcher(), 100);
        }
    },

    setLangifySwitcher() {
      const switcher = document.querySelector('.ly-switcher-wrapper');
      const footerLocalization = document.querySelector('.footer-block--localization');
      if (switcher && footerLocalization) {
        switcher.classList.remove('fixed', 'absolute', 'bottom_right', 'top_left');
        footerLocalization.appendChild(switcher);
      }
    },

    wrapTables() {
      document.querySelectorAll('.ww-page-drawer__content table').forEach(table => {
        const wrapper = document.createElement('div');
        wrapper.className = "tablewrapper";
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
      });
    }

}

document.addEventListener('DOMContentLoaded', (e) => {
    webweb.init();
});
